import { FC } from "react";
import { CardItemType } from "../../model";
import CardItem from "../CardItem";

interface DashboardCardPropTypes {
  title: string;
  dataSource: CardItemType[];
  errorText?: string;
}

const DashboardCard: FC<DashboardCardPropTypes> = ({
  title,
  dataSource,
  errorText,
}) => {
  return (
    <div className="dashboard-card">
      <h4>{title}</h4>

      <div className="card-list">
        {dataSource.map((data, index) => (
          <CardItem key={index} {...data} />
        ))}

        {dataSource.length === 0 && (
          <span className="error-text">{errorText}</span>
        )}
      </div>
    </div>
  );
};

export default DashboardCard;
